/*
 * facecloud后台index页面
 * @Author: ljb
 * @Date: 2018-03-26 10:18:23
 * @Last Modified by: ljb
 * @Last Modified time: 2019-11-18 15:47:19
 */
<style lang="less" rel="stylesheet/less" type="text/less">
.left {
  width: 15%;
  position: fixed;
  z-index: 5;
}
.index {
  position: absolute;
  right: 0;
  padding-bottom: 48px;
  width: 85%;
  // height: 100%;
}
.clear {
  //  content: '';
  //  display:block;
  //  clear: both;
  //  height: 100%;
}
// 版权文字区
.copy-right {
  text-align: center;
  padding: 10px 0 20px;
  color: #9ea7b4;
  // position: absolute;
  width: 100%;
  min-width: 1186px;
  bottom: 0;
  background-color: #f0f0f0;
  position: fixed;
}
</style>
<template>
  <div class="clear">
    <leftNavigation class="left" />
    <div class="index">
      <breadcrumb />
      <router-view />
      <div class="copy-right">
        <p>本服务由广州帕克西软件开发有限公司提供，客服电话：020-82520103 18688883944</p>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import leftNavigation from "./left-navigation.vue";
import breadcrumb from "./breadcrumb.vue";

export default {
  components: {
    leftNavigation,
    breadcrumb
  }
};
</script>
